export var contentSizeMap = {
  m: 'body-small',
  s: 'caption-medium'
};
export var colorMap = {
  light: 'primary',
  brand: 'black',
  dark: 'primary-invert',
  accent: 'white',
  error: 'white',
  success: 'white',
  surface: 'black'
};
export var iconColorMap = {
  light: 'primary',
  brand: 'black',
  dark: 'primary-invert',
  accent: 'white',
  error: 'white',
  success: 'white',
  surface: 'black'
};